import axios from "../axios.js";
// let urlType = 'http://pm.imlimit.com/index/'

var api = {
  // 获取二维码 => 登录页面
  getCode(params) {
    // https://pm.imlimit.com/index/index/sendVerifyCode
    return axios.post("index/index/sendVerifyCode", params);
  },
  //登录页登录  => 手机验证码登录
  getSign(params) {
    return axios.post("index/index/cacheCode", params);
  },
  //登录页登录  =>  账号密码登录
  getLogPwd(params) {
    return axios.post("index/index/checkPwd", params);
  },
  //账号退出
  goLoginOut() {
    return axios.post("index/index/logout");
  },
  //分块
  baseParams() {
    return axios.post("index/topic/baseParam");
  },
  //tdk
  seo() {
    return axios.post("index/seo/list");
  },
  //微信登录
  wxqrcode(params) {
    return axios.post("index/index/wxqrcode", params);
  },
};

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js